'use client';
import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { z } from 'zod';
import Link from 'next/link';
import { PAGE_PATHS } from '@/constants/constants';

export const subscriberInfoSchema = z.object({
  firstName: z.string().min(2, 'First name should have at least 2 characters'),
  lastName: z.string().min(2, 'Last name should have at least 2 characters'),
  email: z
    .string()
    .email('Invalid email address')
    .min(2, 'Email address is required')
});

type FormData = z.infer<typeof subscriberInfoSchema>;

export default function NewSubscriberDetails() {
  const {
    register,
    formState: { errors }
  } = useFormContext<FormData>();

  return (
    <Stack direction='column' textAlign='center' maxWidth={800} width='100%'>
      <Stack direction={{ xs: 'column', sm: 'row' }} width='100%'>
        <TextField
          required
          fullWidth
          id='firstName'
          label='First name'
          {...register('firstName')}
          error={!!errors.firstName}
          helperText={errors.firstName?.message}
        />
        <TextField
          required
          fullWidth
          id='lastName'
          label='Last name'
          {...register('lastName')}
          error={!!errors.lastName}
          helperText={errors.lastName?.message}
        />
        <TextField
          required
          fullWidth
          id='email'
          label='Email Address'
          autoComplete='email'
          {...register('email')}
          error={!!errors.email}
          helperText={errors.email?.message}
        />
      </Stack>
      <Typography variant='body1'>
        By submitting, you agree to The Urban Developer’s{' '}
        <Link
          target='_blank'
          href={PAGE_PATHS.privacyPolicy}
          prefetch={false}
          style={{ textDecoration: 'underline', color: 'inherit' }}
        >
          Privacy Policy
        </Link>{' '}
        and{' '}
        <Link
          target='_blank'
          href={PAGE_PATHS.termsAndConditions}
          prefetch={false}
          style={{ textDecoration: 'underline', color: 'inherit' }}
        >
          Terms and Conditions
        </Link>
      </Typography>
    </Stack>
  );
}
